import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatorModel } from 'symbols';
import { EquipmentModel } from '../symbols';

@Injectable()
export class EquipmentsService {
  readonly api = '/api/equipment/';

  constructor(private http: HttpClient) {
  }

  getEquipmentList(search: string, onlyWithPreparedForUse = false): Observable<PaginatorModel<EquipmentModel>> {
    return this.http.get<PaginatorModel<EquipmentModel>>(`${this.api}list`, {params: {search, onlyWithPreparedForUse}});
  }

  getEquipmentByQrCode(qrCode: string): Observable<EquipmentModel> {
    return this.http.get<EquipmentModel>(`${this.api}equipment-by-qr/${qrCode}`);
  }

  getEquipmentBySn(sn: string): Observable<EquipmentModel> {
    return this.http.get<EquipmentModel>(`${this.api}equipment-by-sn/${sn}`);
  }
}
